<template lang="html">
  <div class="wrapper">
    <load-spinner v-if="showSpinner"></load-spinner>
    <b-modal ref="req-result">
      <p class="my-4"
         v-bind:class="{ 'message-success' : this.reqSuccess, 'message-fail': !this.reqSuccess } ">{{
          reqResult
        }}</p>
    </b-modal>

    <div class="discounts">
      <p><h4 style="text-align: center">Знижки</h4></p>
      <b-row>
        <b-col v-for="volume of getFullFuelVolumes().slice(0, 2)" cols="2">
          {{ fuelVolumes[volume].volume }}
          <b-form-input
              v-model="fuelVolumes[volume].discount"
              @focusout="parseDefaultPrice"
          >
          </b-form-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col v-for="volume of getFullFuelVolumes().slice(2, 4)" cols="2">
          {{ fuelVolumes[volume].volume }}
          <b-form-input
              v-model="fuelVolumes[volume].discount"
              @focusout="parseDefaultPrice"
          >
          </b-form-input>
        </b-col>
      </b-row>
    </div>

    <div v-if="ready">
      <p><h4 style="text-align: center">Ціни</h4></p>
      <div class="pre-region">
        <b-row>
          <b-col cols="4">
            <p class="title">Область</p>
          </b-col>
          <b-col cols="2" v-for="ft in getFuelTypes()">
            <p class="text">{{ ft }}</p>
          </b-col>
        </b-row>
      </div>

      <div v-for="region in getRegions()" v-bind:key="region" class="region">
        <b-row>
          <b-col cols="4">
            <p class="title"> {{ region }}</p>
          </b-col>
          <b-col cols="2" v-for="fuelType in getFuelTypes()">
            <b-form-input v-model="defaultPrices[region][fuelType].price"
                          @focusout="() => updateDefaultPrice(defaultPrices[region][fuelType])"></b-form-input>
          </b-col>
        </b-row>
        <b-row v-for="volume in getVolumes(region)" v-bind:key="volume" class="volume">
          <b-col cols="4">
            <p class="title"> {{ volume }}</p>
          </b-col>
          <b-col cols="2" v-for="fuelType in getFuelTypes()">
            <b-form-input
                style="background-color: white"
                v-model="items[region][volume][fuelType].price"
                :state="validPrice(getPrice(region, volume, fuelType).price) === false ? false : null"
                readonly
            ></b-form-input>
            <!--                @focusout="() => editPrices(items[region][volume][fuelType])"-->
          </b-col>
        </b-row>
      </div>
      <div class="buttons">
        <b-button variant="success" @click="() => compute()">Розрахувати</b-button>
      </div>
    </div>

  </div>
</template>

<script lang="js">
import LoadSpinner from '../components/LoadSpinner';
import {getPrices, updatePrice, updatePriceBatch} from "@/services/Prices.service";
import axios from "axios";
import {server} from "@/variables";

export default {
  name: 'src-components-prices',
  props: [],
  components: {LoadSpinner},
  async mounted() {
    await this.loadData();
  },
  data() {
    return {
      reqSuccess: true,
      reqResult: '',
      showSpinner: false,
      message: '',
      result: '',

      items: {},
      copy: {},

      cantStore: false,
      reload: true,

      ready: false,
      defaultPrices: {},

      fuelVolumes: {},
    }
  },
  methods: {
    showModal() {
      this.$refs['req-result'].show();
      setTimeout(() => {
        this.$refs['req-result'].hide();
      }, 2000);
    },
    getRegions() {
      return Object.keys(this.items).sort();
    },
    getVolumes() {
      return ['5000л - 9999л', '10000л - 19999л', '20000л - 40000л', '40000л+'];
    },
    getFuelTypes() {
      const region = Object.keys(this.items)[0];
      const volume = Object.keys(this.items[region])[0];
      return Object.keys(this.items[region][volume]).sort();
    },
    getPrice(region, volume, fuelType) {
      // let vlm = volume.indexOf('-') === -1 ? `${volume}л+` : volume.split('-').map(v => `${v}л`).join('-');
      return this.items[region][volume][fuelType];
    },
    validPrice(val) {
      let coins = val.toString().split('.');
      val = +val;
      return val > 0 && !isNaN(val) && (!coins[1] || coins[1].length <= 2);
    },
    async storePrice(prices) {
      this.showSpinner = true;
      try {
        await updatePriceBatch({prices});
        this.reqResult = 'Дані змінені';
        this.reqSuccess = true;
      } catch (err) {
        this.reqResult = 'Трапилася помилка на сервері, зверніться до адміністратора';
        this.reqSuccess = false;
      }
      this.showModal();
    },
    async compute() {
      this.showSpinner = true;
      const prices = [];
      let store = true;
      for (const region of this.getRegions()) {
        for (const fuelVolume of this.getFullFuelVolumes()) {
          for (const fuelType of this.getFuelTypes()) {
            // console.log(fuelVolume, this.items[region][fuelVolume])
            this.defaultPrices[region][fuelType].price = +(this.defaultPrices[region][fuelType].price.toString().replace(',', '.'));
            let volume = this.fuelVolumes[fuelVolume];
            this.defaultPrices[region][fuelType].price = +(this.defaultPrices[region][fuelType].price.toString().replace(',', '.'));
            if (isNaN(this.defaultPrices[region][fuelType].price)) {
              store = false;
            }
            this.items[region][volume.volume][fuelType].price = +(this.defaultPrices[region][fuelType].price - volume.discount).toFixed(2);
            prices.push({
              id: this.items[region][volume.volume][fuelType].id,
              price: this.items[region][volume.volume][fuelType].price
            });
          }
        }
      }
      if (store) {
        await this.storePrice(prices);
        this.showSpinner = false;
      }
    },
    updateDefaultPrice(region) {
      const token = localStorage.getItem('token');
      return new Promise((resolve, reject) => {
        axios.post(`${server}/prices/default`, {
          fuelRegionDefaultId: region.id,
          price: region.price
        }, {headers: {'admin-token': token}})
            .then((data) => {
              return resolve(data.data)
            })
            .catch(err => {
              reject(err);
            });
      })
    },

    getFullFuelVolumes() {
      return Object.keys(this.fuelVolumes);
    },
    parseDefaultPrice() {
      this.fuelVolumes = this.fuelVolumes.map(i => {
        let discount = i.discount;
        discount = discount.toString().replace(',', '.');
        if (isNaN(discount)) {
          discount = 0;
        } else if (!discount) {
          discount = 0;
        } else {
          discount = (+discount).toFixed(2)
        }
        i.discount = discount;
        this.editVolume(i);
        return i;
      });
    },
    editVolume(volume) {
      this.showSpinner = true;
      const token = localStorage.getItem('token');
      return new Promise((resolve, reject) => {
        axios.post(`${server}/discount`, {
          volumeId: volume.id,
          discount: volume.discount
        }, {headers: {'admin-token': token}})
            .then(async (data) => {
              await this.compute();
              // await this.loadData();
              this.showSpinner = false;
              return resolve(data.data)
            })
            .catch(err => {
              this.showSpinner = false;
              reject(err);
            });
      })
    },
    loadData() {
      return new Promise((resolve, reject) => {
        this.showSpinner = true;
        getPrices()
            .then(({regions: regionsSrc, fuelVolumes: fuelVolumesSrc, fuelPrices, fuelTypes: fuelTypesSrc, fuelDefault}) => {
              let regions = [];
              let fuelVolumes = [];
              let fuelTypes = [];

              let fuelRegionPrices = {};
              const items = {};

              regionsSrc.forEach(r => {
                regions[r.id] = r;
              });

              fuelVolumesSrc.forEach(fv => {
                fuelVolumes[fv.id] = fv;
              });

              this.fuelVolumes = fuelVolumes.map(i => {
                i.discount = (+i.discount).toFixed(2)
                return i;
              });
              fuelTypesSrc.forEach(ft => {
                fuelTypes[ft.id] = ft;
              });

              fuelPrices.forEach((fp, i, arr) => {
                arr[i].volume = fuelVolumes[fp['fuelVolumeId']]['volume'];
                arr[i].discount = fuelVolumes[fp['fuelVolumeId']]['discount'];
                const region = regions[fp['regionId']]['uaShort'];
                if (!items[region]) {
                  items[region] = {};
                  fuelRegionPrices[region] = {};
                }

                if (fuelRegionPrices[region][arr[i].volume]) {
                  fuelRegionPrices[region][arr[i].volume] = 0;
                }

                if (!items[region][arr[i].volume]) {
                  items[region][arr[i].volume] = {};
                }
                const fuelType = fuelTypes[fp['fuelTypeId']].type;
                if (!items[region][arr[i].volume][fuelType]) {
                  items[region][arr[i].volume][fuelType] = fp;
                }
              })

              for (let i = 1; i < regions.length; i += 1) {
                for (let j = 1; j < fuelTypes.length; j += 1) {
                  if (!fuelRegionPrices[regions[i]['uaShort']]) {
                    fuelRegionPrices[regions[i]['uaShort']] = {};
                  } else {
                    let def = fuelDefault.find((x) => x.regionId === regions[i].id && x.fuelTypeId === fuelTypes[j].id);
                    fuelRegionPrices[regions[i]['uaShort']][fuelTypes[j].type] = {price: def.price, id: def.id};
                  }
                }
              }

              this.items = items;
              this.copy = JSON.parse(JSON.stringify(items));
              this.fuelVolumes = fuelVolumes;
              this.defaultPrices = fuelRegionPrices;

              this.showSpinner = false;
              this.ready = true;
              resolve();
            })
            .catch(() => {
              this.showSpinner = false;
              this.reqResult = 'Трапилася помилка на сервері, зверніться до адміністратора';
              this.reqSuccess = false;

              this.showModal();
              reject();
            })
      })
    }
  },
  computed: {},
  watch: {}
}
</script>

<style lang="scss">
.wrapper {
  padding: 16px 32px;

  .discounts {
    margin-bottom: 64px;

    .row {
      justify-content: center;
    }
  }

  .discounts,
  .pre-region {
    display: flex;
    flex-direction: column;
  }

  .region {
    display: flex;
    flex-direction: column;
    margin-bottom: 24px;

    .row {
      width: 100%;
      align-items: center;
    }
  }

  .row .title {
    text-align: end;
    padding: 0;
    margin: 0;
  }

  .row .text {
    text-align: center;
  }

  .buttons {
    display: flex;
    justify-content: center;
  }
}

.message-fail {
  color: red !important;
}

.message-success {
  color: green;
}
</style>
